import { Config } from 'containers/AppContainer/typings';
import {
  isNextOfKinsSubstantive,
  isNextOfKinsWithFormRejection,
} from 'containers/CourtManagerLegalProceedings/AppealOnMerits/utils';
import { JUDGEMENT_ON_MERITS_VICTIM } from 'containers/data-structure';
import { get } from 'lodash';
import messages from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/messages';
import { translate } from 'containers/services/translate';
import validate from 'containers/services/validateForm';

export const shouldValidateDesceasedVictim = (
  desceasedVictim: any,
  civilJudgementVictimReason: Config[],
  jmv: any,
  props: any,
) => {
  const currentJudgementVictim = jmv.find(
    (el: any) =>
      el.victimId === get(desceasedVictim, 'id', desceasedVictim?.victimId),
  );
  const validationErrors = validate(
    {
      ...currentJudgementVictim,
      medicalFees: formatNumberToString(
        get(currentJudgementVictim, 'medicalFees'),
      ),
      funeralFees: formatNumberToString(
        get(currentJudgementVictim, 'funeralFees'),
      ),
      compensationAmount: formatNumberToString(
        get(currentJudgementVictim, 'compensationAmount'),
      ),
    },
    desceasedVictimConstraint(desceasedVictim, civilJudgementVictimReason),
  );
  if (validationErrors) {
    const { requiredErrors, alertErrors } = processValidationResults(
      validationErrors,
      props,
    );

    return { requiredErrors, alertErrors };
  }
};
const formatNumberToString = (value: any) => {
  return value !== null && value !== undefined && typeof value === 'number'
    ? String(value)
    : value;
};
export const processValidationResults = (validationErrors: any, props: any) => {
  return Object.entries(validationErrors).reduce(
    (result, [field, messages]: any) => {
      const requiredError = messages.find((msg: any) =>
        msg.id.includes('required'),
      );
      const alertError = messages.find(
        (msg: any) => !msg.id.includes('required'),
      );
      if (requiredError) {
        result.requiredErrors[field] = translate(requiredError, props);
      }
      if (alertError) {
        result.alertErrors[field] = translate(alertError, props);
      }
      return result;
    },
    { requiredErrors: {}, alertErrors: {} } as {
      requiredErrors: Record<string, string>;
      alertErrors: Record<string, string>;
    },
  );
};
export const desceasedVictimConstraint = (
  desceasedVictim: any,
  civilJudgementVictimReason: Config[],
) => {
  const isSubstantiveCase = isNextOfKinsSubstantive(
    get(desceasedVictim, 'beneficiaries', []),
    civilJudgementVictimReason,
  );
  const isFormRejectionCase = isNextOfKinsWithFormRejection(
    get(desceasedVictim, 'beneficiaries', []),
    civilJudgementVictimReason,
  );

  return {
    [JUDGEMENT_ON_MERITS_VICTIM.MEDICAL_FEES]: {
      presence: false,
      ...(isSubstantiveCase
        ? {
            format: {
              pattern: /^(0|)$/,
              message: messages.substantiveValidationError,
            },
          }
        : isFormRejectionCase
        ? {
            format: {
              pattern: /^(0|)$/,
              message: messages.formValidationError,
            },
          }
        : undefined),
    },
    [JUDGEMENT_ON_MERITS_VICTIM.COMPENSATION_AMOUNT]: {
      presence: isSubstantiveCase ? true : isFormRejectionCase ? false : true,
      ...(isSubstantiveCase
        ? {
            numericality: {
              equalTo: 0,
              message: messages.substantiveValidationError,
            },
          }
        : isFormRejectionCase
        ? {
            format: {
              pattern: /^(0|)$/,
              message: messages.formValidationError,
            },
          }
        : undefined),
    },
    [JUDGEMENT_ON_MERITS_VICTIM.FUNERAL_FEES]: {
      presence: false,
      ...(isSubstantiveCase
        ? {
            format: {
              pattern: /^(0|)$/,
              message: messages.substantiveValidationError,
            },
          }
        : isFormRejectionCase
        ? {
            format: {
              pattern: /^(0|)$/,
              message: messages.formValidationError,
            },
          }
        : undefined),
    },
  };
};
